import C from "../actionTypes";

export const tableList = (state = [], action) => {
    switch (action.type) {
        case C.CLUB_TABLES_SUCCESS:
            return action.tableList;
        case C.RESET_CLUB_TABLES:
            return [];
        default:
            return state
    }
};
